import * as React from 'react';
import {
    Edit,
    TextInput,
    BooleanInput,
    AutocompleteArrayInput,
    SimpleForm,
    DeleteButton,
    Toolbar,
    SaveButton,
    required,
    useTranslate,
} from 'react-admin';
import default_sets from './default_sets';
import { Grid } from '@mui/material';

import FullNameField from './FullNameField';

const req = [required()];

const onRedirect = () => {
    return `settings/logix/`;
};

const EditToolbar = () => (
    <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <SaveButton />
    </Toolbar>
);

const EntityEdit = () => {
    const translate = useTranslate();

    return (
        <Edit
            resource="settings/serializable"
            queryOptions={{
                meta: {
                    namespace: 'ApiLogix',
                    path: 'orders_filter_status_sets',
                },
            }}
            mutationOptions={{
                meta: {
                    namespace: 'ApiLogix',
                    path: 'orders_filter_status_sets',
                },
            }}
            title={<EditTitle />}
            mutationMode="pessimistic"
            redirect={onRedirect}
        >
            <SimpleForm toolbar={<EditToolbar />}>
                <div>
                    <Grid
                        container
                        width={{ xs: '100%', xl: '80%' }}
                        spacing={2}
                    >
                        <Grid item xs={12} md={10} xl={12}>
                            <TextInput
                                source="label"
                                label={translate(
                                    'resources.orders_filter_status_sets.fields.label'
                                )}
                                fullWidth
                                isRequired
                                validate={req}
                            />
                            <AutocompleteArrayInput
                                source="set"
                                choices={default_sets}
                                label={translate(
                                    'resources.orders_filter_status_sets.fields.set'
                                )}
                                fullWidth
                                isRequired
                                validate={req}
                            />
                            <BooleanInput
                                source="front"
                                label={translate(
                                    'resources.orders_filter_status_sets.fields.front'
                                )}
                                fullWidth
                                defaultValue={true}
                            />
                        </Grid>
                    </Grid>
                </div>
            </SimpleForm>
        </Edit>
    );
};

// @ts-ignore
const EditTitle = () => <FullNameField size="32" sx={{ margin: '5px 0' }} />;

export default EntityEdit;
